import { BaseViewStore } from 'core/stores';
import { action, observable, set, runInAction } from "mobx";
import { LookupService } from "common/services"
import React from 'react';
import { ModalParams } from 'core/models';

class NikoPatientTemplateItemCalculationModalStore extends BaseViewStore {
    @observable accessor isEnteredTotalWrong = false;
    @observable accessor tempValues = {};
    @observable accessor isRecalculateDisabled = false;
    @observable accessor patientTemplateItem = null;
    @observable accessor patientTemplateItemRef = null;
    @observable accessor isTab = false;
    @observable accessor isSavingResource = false;
    constructor(rootStore, componentProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.item = componentProps.modalParams.data.patientTemplateItem;
        this.patientTemplateItem = { ...this.item, mlph: 0, frequency: 0, itemMls: 0, itemCals: 0 };
        this.facilityId = componentProps.modalParams.data.facilityId;
        this.updateItem = componentProps.modalParams.data.updateItem;

        if (this.item.note) {
            this.getNoteQuantity(/(\d*(?:\.\d*)?)(.ml\*)/, "mlph")
            this.getNoteQuantity(/(\d*(?:\.\d*)?)(.hrs|.=)/, "frequency");
            this.getNoteQuantity(/(\d*(?:\.\d*)?)(.ml|.can|.cans|.lps)(?!\*)/, "itemMls");
            this.getNoteQuantity(/\d*(?:[.,]?\d*)?(?=\s*[kK]?[cC]al)/, "itemCals");
        }

        this.patientTemplateItemRef = {
            mlph: React.createRef(),
            frequency: React.createRef(),
            itemMls: React.createRef(),
            itemCals: React.createRef()
        };

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.showTemplateChangeWarning = this.modalParams.data.showTemplateChangeWarning;
        this.patientTemplateItemService = componentProps.modalParams.data.patientTemplateItemService
        this.lookupService = new LookupService(rootStore.application.baasic.apiClient);
        this.setTempValues();

        this.calculationConfirmModal = new ModalParams({ onClose: null });
        this.calculationConfirmModal.onConfirm = async () => { this.updatePatientTemplateItem(); this.calculationConfirmModal.close(); };
        this.calculationConfirmModal.onCancel = () => { this.calculationConfirmModal.close() };
        this.fetch([this.initialize()]);
    }

    @action
    async initialize() {
        await this.showWarningMessage("");
        this.setIsRecalculateDisabled();
    }

    @action.bound
    setIsRecalculateDisabled() {
        let arry = [this.patientTemplateItem.itemCals, this.patientTemplateItem.itemMls, this.patientTemplateItem.mlph, this.patientTemplateItem.frequency]
        this.isRecalculateDisabled = arry.filter(i => i === "").length > 2 || (this.patientTemplateItem.mlph === "" && this.patientTemplateItem.frequency === "");
    }

    @action
    getNoteQuantity(regex, propertyName) {
        let match = this.item.note.toLowerCase().match(regex);
        if (match && match[0] && parseFloat(match[0])) {
            this.patientTemplateItem[propertyName] = parseFloat(match[0]);
        }
    }

    @action.bound
    editItem(value, name, propertyName) {
        const number = parseFloat(value);
        if(isNaN(number) && value != "")
            return;

        let roundedString = value;
        if (!isNaN(number) && !roundedString.endsWith(".")) {
            const roundedNumber = Math.floor(number * 10) / 10;
            roundedString = roundedNumber.toString();
        }

        this.patientTemplateItem[name] = roundedString;
        this.setIsRecalculateDisabled();
        this.selectedField = { name: name, propertyName: propertyName };
    }

    @action.bound
    async calculateQuantity(propertyName, name, selected) {
        if (parseFloat(this.tempValues[name]) === parseFloat(this.patientTemplateItem[name])) {
            return;
        }

        if (this.patientTemplateItem[name] === "") {
            runInAction(() => {
                this.tempValues[name] = "";
                this.isEnteredTotalWrong = false;
            });
            return;
        }
        if (this.patientTemplateItem[name] != this.tempValues[name] || propertyName === "itemMlph" || propertyName === "itemFrequency") {
            await this.showWarningMessage(propertyName);
            if (!this.isEnteredTotalWrong) {
                var response = (await this.patientTemplateItemService.calculateQuantity({
                    productId: this.patientTemplateItem.product.id,
                    orderQuantity: 0,
                    templateQuantity: this.patientTemplateItem.quantity,
                    itemCals: this.patientTemplateItem.itemCals ? this.patientTemplateItem.itemCals : 0,
                    itemMls: this.patientTemplateItem.itemMls ? this.patientTemplateItem.itemMls : 0,
                    itemMlph: this.patientTemplateItem.mlph ? this.patientTemplateItem.mlph : 0,
                    frequency: this.patientTemplateItem.frequency ? this.patientTemplateItem.frequency : 0,
                    changedValue: propertyName,
                    facilityId: this.facilityId
                })).data;

                runInAction(() => {
                    this.patientTemplateItem.quantity = response.templateQuantity;
                    this.patientTemplateItem.itemCals = response.itemCals;
                    this.patientTemplateItem.itemMls = response.itemMls;
                    this.patientTemplateItem.mlph = response.mlph;
                    this.patientTemplateItem.frequency = response.frequency;
                });
            }
            this.setTempValues();
        }

        if (this.isTab && selected) {
            this.patientTemplateItemRef[selected].current.focus();
            this.patientTemplateItemRef[selected].current.select();
        }
        this.isTab = false;
    }

    @action.bound
    async recalculateQuantity() {
        var hasAllData = !!this.patientTemplateItem.itemCals && !!this.patientTemplateItem.itemMls && !!this.patientTemplateItem.mlph && !!this.patientTemplateItem.frequency;
        try {
            var response = (await this.patientTemplateItemService.calculateQuantity({
                productId: this.patientTemplateItem.product.id,
                orderQuantity: 0,
                templateQuantity: this.patientTemplateItem.quantity,
                itemCals: !hasAllData && this.patientTemplateItem.itemCals ? this.patientTemplateItem.itemCals : null,
                itemMls: !hasAllData && this.patientTemplateItem.itemMls ? this.patientTemplateItem.itemMls : null,
                itemMlph: this.patientTemplateItem.mlph ? this.patientTemplateItem.mlph : null,
                frequency: this.patientTemplateItem.frequency ? this.patientTemplateItem.frequency : null,
                facilityId: this.facilityId,
                isRecalculate: true
            })).data;
        }
        catch (err) {
            return;
        }

        runInAction(() => {
            this.patientTemplateItem.quantity = response.templateQuantity;
            this.patientTemplateItem.itemCals = response.itemCals;
            this.patientTemplateItem.itemMls = response.itemMls;
            this.patientTemplateItem.mlph = response.mlph;
            this.patientTemplateItem.frequency = response.frequency;
            this.isEnteredTotalWrong = false;
        });
        this.setTempValues();
    }

    @action.bound
    async updatePatientTemplateItem() {
        this.lookups = await this.lookupService.getLookups("ItemType");
        if (this.showTemplateChangeWarning && this.item.quantity != this.patientTemplateItem.quantity) {
            this.showTemplateChangeWarning();
        }

        set(this.item, 'actionId', this.patientTemplateItem.actionId);
        set(this.item, 'quantity', this.patientTemplateItem.quantity);
        set(this.item, 'salesOrderQuantity', this.patientTemplateItem.quantity);
        set(this.item, 'mlph', this.patientTemplateItem.mlph);
        set(this.item, 'frequency', this.patientTemplateItem.frequency);
        set(this.item, 'itemMls', this.patientTemplateItem.itemMls);
        set(this.item, 'itemCals', this.patientTemplateItem.itemCals);
        let hrs = (this.patientTemplateItem.product.itemTypeId == this.lookups.itemType.find(x => x.abrv === "can").id || (this.patientTemplateItem.product.procedureCode_ && this.patientTemplateItem.product.procedureCode_.abrv === "B4155")) ? '' : 'hrs';
        let noteValue = this.item.mlph === 0 && this.item.frequency === 0 ? this.item.itemMls + 'ml-' + this.item.itemCals + 'kcals' : this.item.mlph + 'ml*' + this.item.frequency + `${hrs}=` + this.item.itemMls + 'ml-' + this.item.itemCals + 'kcals';
        set(this.item, 'note', noteValue);

        this.updateItem && this.updateItem(this.item);

        this.addVisualCueToChanges();
        this.modalParams.close();
    }

    @action.bound
    async updateResource() {
        try {
            this.isSavingResource = true;
            if (this.patientTemplateItem.itemMls === "" || this.patientTemplateItem.itemCals === "" || this.patientTemplateItem.itemMls == 0 || this.patientTemplateItem.itemCals == 0) {
                this.isEnteredTotalWrong = true;
                this.isSavingResource = false;
                this.errorMessage = "Some information is missing, please review and recalculate.";
                return;
            }

            if (this.isEnteredTotalWrong) {
                this.calculationConfirmModal.open({
                    message: "Entered values contradict each other. Are you sure you want to save the changes?"
                });
            }
            else {
                if (!this.selectedField) {
                    this.selectedField = { name: "itemCals", propertyName: "itemCals" };
                }
                await this.calculateQuantity(this.selectedField.propertyName, this.selectedField.name, null);
                await this.updatePatientTemplateItem();
            }
            this.isSavingResource = false;
        }
        catch (err) {
            this.isSavingResource = false;
            return this.onUpdateError(err);
        }
    }

    @action.bound
    async showWarningMessage(propertyName) {
        if (this.patientTemplateItem.itemMls === "" || this.patientTemplateItem.itemCals === "" || this.patientTemplateItem.mlph === "" || this.patientTemplateItem.frequency === ""
            || this.patientTemplateItem.itemMls == 0 || this.patientTemplateItem.itemCals == 0 || this.patientTemplateItem.mlph == 0 || this.patientTemplateItem.frequency == 0) {
            return;
        }

        var recalculatedQuantity = await this.getRecalculatedQuantity();
        runInAction(() => {
            if (((propertyName == "" || propertyName === "itemMls") && this.patientTemplateItem.itemMls != recalculatedQuantity.itemMls) ||
                ((propertyName == "" || propertyName === "itemCals") && this.patientTemplateItem.itemCals != recalculatedQuantity.itemCals)) {
                this.errorMessage = "Entered values contradict each other.";
                this.isEnteredTotalWrong = true;
            }
            else {
                this.isEnteredTotalWrong = false;
            }
        });
    }

    @action.bound
    setTempValues() {
        this.tempValues["mlph"] = this.patientTemplateItem.mlph;
        this.tempValues["frequency"] = this.patientTemplateItem.frequency;
        this.tempValues["itemMls"] = this.patientTemplateItem.itemMls;
        this.tempValues["itemCals"] = this.patientTemplateItem.itemCals;
    }

    @action.bound
    async getRecalculatedQuantity() {
        var hasAllData = !!this.patientTemplateItem.itemCals && !!this.patientTemplateItem.itemMls && !!this.patientTemplateItem.mlph && !!this.patientTemplateItem.frequency;
        try {
            var response = (await this.patientTemplateItemService.calculateQuantity({
                productId: this.patientTemplateItem.product.id,
                orderQuantity: 0,
                itemCals: !hasAllData && this.patientTemplateItem.itemCals ? this.patientTemplateItem.itemCals : null,
                itemMls: !hasAllData && this.patientTemplateItem.itemMls ? this.patientTemplateItem.itemMls : null,
                templateQuantity: this.patientTemplateItem.quantity,
                itemMlph: this.patientTemplateItem.mlph ? this.patientTemplateItem.mlph : null,
                frequency: this.patientTemplateItem.frequency ? this.patientTemplateItem.frequency : null,
                facilityId: this.facilityId,
                isRecalculate: true
            })).data;
            return response;
        }
        catch (err) { 
            return;
        }
    }

    @action.bound
    handleKeyDown(event) {
        if (event.key === 'Tab') {
            this.isTab = true;
        }
    }

    addVisualCueToChanges() {
        if (this.item.patientTemplateItemInitial && this.item.quantity != this.item.patientTemplateItemInitial.quantity)
            this.item.isTemplateQuantityChanged = true;
        else
            this.item.isTemplateQuantityChanged = false;

        if (this.item.patientTemplateItemInitial && this.item.note != this.item.patientTemplateItemInitial.note)
            this.item.isNoteChanged = true;
        else
            this.item.isNoteChanged = false;
    }
}

export default NikoPatientTemplateItemCalculationModalStore;
